// Small shared pieces for the ported engine: its messages show as the app's toasts.
import { toast as appToast } from '../web/ui.js';

export const esc = (s) => String(s ?? '')
  .replaceAll('&', '&amp;').replaceAll('<', '&lt;').replaceAll('>', '&gt;')
  .replaceAll('"', '&quot;').replaceAll("'", '&#39;');

// The engine writes its messages in Title Case ("Rink Moved Up"); toasts read
// better as a sentence, so the first letter stays and the rest drops to lower
// case unless a word is all caps (PNG, GIF) or a quoted name.
const sentence = (msg) => String(msg).replace(/ - /g, ': ').replace(/(^|[\s-])([A-Z])([a-z]+)/g, (m, sp, a, b, off) => (off === 0 ? m : `${sp}${a.toLowerCase()}${b}`));

export function toast(msg, isErr = false) {
  appToast(`${isErr ? 'CTH Diagrams: ' : ''}${sentence(msg)}`, isErr ? 6000 : 2600);
}
